/**
 * @generated SignedSource<<4d4aac86f6380c880aa495d1b66d041b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ErrorReportDeleteInput = {
  id: string;
};
export type TaskId_errorReportDeleteMutation$variables = {
  input: ErrorReportDeleteInput;
};
export type TaskId_errorReportDeleteMutation$data = {
  readonly errorReportDelete: {
    readonly id: string;
  };
};
export type TaskId_errorReportDeleteMutation = {
  response: TaskId_errorReportDeleteMutation$data;
  variables: TaskId_errorReportDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ErrorReport",
    "kind": "LinkedField",
    "name": "errorReportDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskId_errorReportDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskId_errorReportDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "357462f84455bdb173023e6132a2bd26",
    "id": null,
    "metadata": {},
    "name": "TaskId_errorReportDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TaskId_errorReportDeleteMutation(\n  $input: ErrorReportDeleteInput!\n) {\n  errorReportDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bbbae9162ea2eb7e5f9f966e85bfe2e9";

export default node;
